import { object } from "yup";

import { fieldValidationSchemaGenerator } from "modules/queues/application/fieldValidationSchemaGenerator";
import { IEReservationQueueFormField } from "modules/queues/types/IEReservationQueueFormField";

import { IDynamicFieldSchema } from "utils/yup/IDynamicFieldSchema";

export const useEditUserAppointmentFormValidationSchema = (
  formFields: IEReservationQueueFormField[]
) => {
  let dynamicFieldsSchema: IDynamicFieldSchema = {};

  formFields.forEach((formField) => {
    dynamicFieldsSchema[formField.name] = fieldValidationSchemaGenerator(
      formField
    );
  });

  return object().shape(dynamicFieldsSchema);
};
